import React from "react";
import { Link } from "react-router-dom";
import { projects, notes, profile } from "./content";
import { Arrow } from "./Icons";
import ProjectArt from "./ProjectArt";
import SiteMeta from "./SiteMeta";

export function ContactInvitation() {
  return (
    <section className="contact-invitation" aria-labelledby="invitation-title">
      <div>
        <h2 id="invitation-title">Have something in mind?</h2>
        <p>
          I’m always happy to talk about tools, systems, and things worth
          building.
        </p>
      </div>
      <Link className="button button-light" to="/contact">
        Get in touch <Arrow />
      </Link>
    </section>
  );
}

function ProjectCard({ project, featured }) {
  return (
    <Link
      className={`project-card${featured ? " project-featured" : ""}`}
      to={`/projects#${project.id}`}
      aria-label={`Explore ${project.name}`}
    >
      <ProjectArt project={project.id} />
      <div className="project-card-copy">
        <span className="project-category">{project.category}</span>
        <div className="project-card-title">
          <h3>{project.name}</h3>
          <Arrow diagonal />
        </div>
        <p>{project.summary}</p>
        {featured && (
          <span className="feature-link">
            Explore the project <Arrow />
          </span>
        )}
      </div>
    </Link>
  );
}

export default function Home() {
  return (
    <>
      <SiteMeta />
      <section className="home-intro" aria-labelledby="home-title">
        <div className="intro-copy">
          <h1 id="home-title">
            Hunter Grey<span>.</span>
          </h1>
          <p className="intro-lead">I build the tools I want to use.</p>
          <p className="intro-description">
            Developer tools, personal software, and a little corner of the
            internet I run myself.
          </p>
          <div className="intro-links">
            <Link to="/about" className="text-link">
              A little about me <Arrow />
            </Link>
            <a href={profile.gitlab} target="_blank" rel="noopener noreferrer">
              Find my code <Arrow diagonal />
            </a>
          </div>
        </div>
        <aside className="desk-note">
          <span className="note-date">
            <i /> September 2026
          </span>
          <p>These days, I’m making my editor feel more like home.</p>
          <Link to="/projects#neovibe">
            Working on NeoVibe <Arrow diagonal />
          </Link>
        </aside>
      </section>
      <section className="selected-work" aria-labelledby="work-title">
        <div className="section-heading">
          <h2 id="work-title">Selected work</h2>
          <Link className="text-link" to="/projects">
            All projects <Arrow />
          </Link>
        </div>
        <div className="project-grid">
          {projects.map((project, i) => (
            <ProjectCard
              key={project.id}
              project={project}
              featured={i === 0}
            />
          ))}
        </div>
      </section>
      <section className="recent-section" aria-labelledby="recent-title">
        <div className="recent-heading">
          <h2 id="recent-title">Lately</h2>
          <span>A few things on my desk.</span>
        </div>
        <div className="recent-notes">
          {notes.map((note) => (
            <Link className="recent-note" key={note.title} to={note.to}>
              <h3>
                {note.title}
                <Arrow diagonal />
              </h3>
              <p>{note.text}</p>
            </Link>
          ))}
        </div>
      </section>
      <ContactInvitation />
    </>
  );
}
